import React from 'react'
import { Formik, Field } from 'formik'
import { FlexWrapper, Form } from 'lib/ui/components'
import { FormValues, validation } from './schema'
import { Container } from './styled'
import { SubscriptionFrequencyInput } from 'components/SubscriptionFrequencyInput'

interface Props {
  setQuantity: (param: number) => void
  quantity: number
  frequency: number
  setFrequency: (param: number) => void
}

export const EditForm: React.FC<Props> = ({
  setQuantity,
  quantity,
  frequency,
  setFrequency
}) => {
  const handleSubmit = (values: FormValues) => {
    const frequency = values?.frequency
    const quantity = values?.quantity
    setFrequency(frequency)
    setQuantity(quantity)
  }

  const initialValues: FormValues = {
    quantity,
    frequency
  }
  return (
    <Container>
      <Formik
        initialValues={initialValues}
        validationSchema={validation}
        onSubmit={handleSubmit}
      >
        <Form.Wrapper>
          <Form.FormikObserver<FormValues>
            autoSubmit
          />
          <FlexWrapper
            className='row'
          >
            <Field
              name='quantity'
              label='Quantity'
              component={Form.Input}
            />
            <SubscriptionFrequencyInput
              value={frequency}
              min={2}
              max={20}
              onChange={setFrequency}
              isFormik
              name='frequency'
              label='Frequency in weeks'
            />
          </FlexWrapper>
        </Form.Wrapper>
      </Formik>
    </Container>
  )
}
